import type { Airport } from '@/types';
import { apiFetch } from './apiClient';

const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT;

/**
 * Search airports using the backend API (requires authentication)
 */
export async function searchAirports(query: string): Promise<Airport[]> {
  if (!query || query.length < 2) return [];

  try {
    const response = await apiFetch(
      `${API_ENDPOINT}/airports/search?q=${encodeURIComponent(query)}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API search failed: ${response.status}`);
    }

    const airports: Airport[] = await response.json();
    return airports;
  } catch (error) {
    console.error('Error searching airports via API:', error);
    throw error;
  }
}
